/* eslint-disable prefer-named-capture-group */
import type { FC } from 'react';
import type { NavLinkProps } from 'react-router-dom';

import { NavLink } from './styled';

export const NavigationItem: FC<NavLinkProps> = ({ to, children }) => {
    return (
        <li>
            <NavLink
                className={({ isActive }) => (isActive ? 'active' : undefined)}
                to={to}
            >
                {children}
            </NavLink>
        </li>
    );
};
